import { useTranslation } from 'react-i18next';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { Select } from '../../../components/Select/Select';
import { SelectOption } from '../../../core/types';
import countries from '../../../core/data/homeland_countries.json';
import { useFormik } from 'formik';
import './InvoiceBook.scss';
import { useState } from 'react';
import InvoiceBookResults from './InvoiceBookResults';
import Button from '../../../components/Button';

interface FormValues {
  filing_from?: Date;
  filing_to?: Date;
  vat_country: string;
  departure_country: string;
  arrival_country: string;
}

export default function InvoiceBook() {
  const [isResultsShown, setIsResultShown] = useState(false);

  const formik = useFormik({
    initialValues: {
      filing_from: undefined,
      filing_to: undefined,
      vat_country: '',
      departure_country: '',
      arrival_country: '',
    },
    onSubmit: () => {
      setIsResultShown(true);
    },
  });

  const { t, i18n } = useTranslation();

  const countriesArray: SelectOption[] = (countries as string[])
    .map((c) => ({
      id: c,
      name: t(c),
    }))
    .sort((a, b) => {
      return a.name.localeCompare(b.name, i18n.language);
    })
    .sort((a, b) => {
      return b.name === t('OTHER') ? -1 : a.name === t('OTHER') ? 1 : 0;
    });

  const countriesOptions = [
    {
      id: 'all',
      name: 'All',
    },
    ...countriesArray,
  ];

  const onChangeField = (field: keyof FormValues) => (value: any) => {
    formik.setFieldValue(field, value, true);
    setTimeout(() => {
      formik.setFieldTouched(field, true, true);
    }, 0);
  };

  return (
    <div className='Page flex-grow-1'>
      <div className='container d-flex justify-content-center'>
        <div className='Paper w-100 p-4 Paper--InvoiceBook mx-auto'>
          <div className='Text--30 fw-900 mb-3'>{t('Invoice Book')}</div>
          <div
            className='InvoiceBook__separator mx-n4'
            style={{
              marginBottom: 14,
            }}
          />
          <form className='w-100 pb-4' onSubmit={formik.handleSubmit}>
            <div className='d-flex align-items-end'>
              <DatePicker
                name='filing_from'
                label={t('Start date')}
                selectedDate={formik.values.filing_from}
                initialDate={formik.values.filing_from || new Date()}
                onSelect={onChangeField('filing_from')}
                className='me-3 DatePicker--InvoiceBook'
              />
              <DatePicker
                name='filing_to'
                label={t('End date')}
                selectedDate={formik.values.filing_to}
                initialDate={formik.values.filing_to || new Date()}
                onSelect={onChangeField('filing_to')}
                className='me-3 DatePicker--InvoiceBook'
              />
              <Select
                name='vat_country'
                label={t('VAT country')}
                placeholder='Select'
                options={countriesOptions}
                value={formik.values.vat_country}
                onChange={onChangeField('vat_country')}
                className='Select--InvoiceBook me-3 pb-0'
              />
              <Select
                name='departure_country'
                label={t('Departure country')}
                placeholder='Select'
                options={countriesOptions}
                value={formik.values.departure_country}
                onChange={onChangeField('departure_country')}
                className='Select--InvoiceBook me-3 pb-0'
              />
              <Select
                name='arrival_country'
                label={t('Arrival country')}
                placeholder='Select'
                options={countriesOptions}
                value={formik.values.arrival_country}
                onChange={onChangeField('arrival_country')}
                className='Select--InvoiceBook me-3 pb-0'
              />
              <div>
                <Button type='submit'>{t('Generate')}</Button>
              </div>
            </div>
          </form>
          <div className='InvoiceBook__separator mx-n4' />
          <div className='pt-2'>
            {isResultsShown ? (
              <InvoiceBookResults />
            ) : (
              <div className='Text--20 fw-800 mb-3'>
                {t('No transactions searched')}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
